import {Timer} from 'components/common/Timer'
import {OrderProvider} from 'providers/OrderProvider'
import {CartItems} from './CartItems/CartItems'

export const Left = () => {
  const order = OrderProvider.useOrder()

  return (
    <div className="flex flex-col gap-4 w-full d:w-[740px]">
      <div className="block d:hidden">
        <Timer />
      </div>
      <div className="font-bold text-2xl">Cart overview</div>
      <CartItems order={order} />
    </div>
  )
}
